import { Node, mergeAttributes } from '@tiptap/core'

export const DialogBlock = Node.create({
  name: 'dialogBlock',
  group: 'block',
  content: 'inline*',

  addAttributes() {
    return {
      characterId: { default: '' },
      characterName: { default: '' },
      clipId: { default: '' },
      sourceType: { default: 'dialog' as 'transcription' | 'dialog' | 'empty' },
      audioStale: { default: false },
      dialogIndex: { default: 0 },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-dialog-block]' }]
  },

  renderHTML({ HTMLAttributes }) {
    const charName = HTMLAttributes.characterName || ''
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-dialog-block': '',
        'data-character-id': HTMLAttributes.characterId,
        'data-character-name': charName,
        'data-clip-id': HTMLAttributes.clipId,
        'data-source-type': HTMLAttributes.sourceType,
        class: 'dialog-block',
      }),
      0,
    ]
  },
})
